import * as React from "react";
import { observer } from "mobx-react";

import "./Scoreboard.less"
import { BaseDict } from "./dict";
import { ScoreboardData } from "./data";
import { Loader } from "sb-resp-ui";
import { ScoreboardTypes } from "../../Constants";

@observer
export class Scoreboard extends React.Component<{
    dataProvider: ScoreboardData,
    dict: BaseDict
}, {
    dataProvider: ScoreboardData
}> {
    dict: BaseDict

    constructor(props) {
        super(props);

        this.dict = this.props.dict;

        this.state = {
            dataProvider: this.props.dataProvider,
        }
    }

    render() {
        const ScoreboardComponent = ScoreboardTypes[this.state.dataProvider.scoreboardType];

        return (
            !this.state.dataProvider.isDataLoaded
            ? <Loader/>
            : <ScoreboardComponent scoreboardData={this.state.dataProvider.data} backgroundImg={this.state.dataProvider.backgroundImg} deviceDetect={this.state.dataProvider.deviceDetect} dict={this.dict}/>
        )
    }
}